import { Dealer } from "@/types"

export const dealers: Dealer[] = [
    {
        id: 1,
        name: "Auto Motoprestamos Oriental",
        address: "Calle José Martí #45, San Pedro de Macorís",
        lat: 18.4566342,
        lng: -69.296238,
        phone: "(809) 526-1414",
        schedule: "Lun-Vie: 8:00 AM - 6:00 PM, Sáb: 9:00 AM - 2:00 PM"
    },
    {
        id: 2,
        name: "Importadora Oriental Ramirez",
        address: "Av. Francisco A. Caamaño, San Pedro de Macorís",
        lat: 18.4614093,
        lng: -69.3142985,
        phone: "(809) 526-1515",
        schedule: "Lun-Vie: 8:00 AM - 6:00 PM, Sáb: 9:00 AM - 2:00 PM"
    },
    {
        id: 3,
        name: "Motoprestamos Oriental Higuey",
        address: "Carretera Mella, La Altagracia, Higüey",
        lat: 18.616932,
        lng: -68.706924,
        phone: "(809) 554-1414",
        schedule: "Lun-Vie: 8:00 AM - 6:00 PM, Sáb: 9:00 AM - 2:00 PM"
    },
    {
        id: 4,
        name: "Oriental Ramirez André",
        address: "Av. Duarte, Boca Chica",
        lat: 18.444086,
        lng: -69.632469,
        phone: "(809) 523-1414",
        schedule: "Lun-Vie: 8:00 AM - 6:00 PM, Sáb: 9:00 AM - 2:00 PM"
    },
    {
        id: 5,
        name: "Oriental Ramirez Bonao",
        address: "Av. Aniana Vargas, Bonao",
        lat: 18.939554,
        lng: -70.404884,
        phone: "(809) 525-1414",
        schedule: "Lun-Vie: 8:00 AM - 6:00 PM, Sáb: 9:00 AM - 2:00 PM"
    }
]